export default "https://cdn-static.gokick.com/assets/abc7ffeff8198bd9a29b582a19941a8ba3b1c5b9/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";